Ext.define('SA.view.TextField2', {
    alias: 'widget.sa-text-field',
    extend: 'Ext.Component',

    baseCls: 'sa-text-field',
    childEls: ['inputEl'],
    clearButton: false,

    maxLength: 96,

    buttons: {
        'sa-text-field-clear': 'onClearClick'
    },

    renderTpl: [
        '<tpl if="icon">',
            '<svg aria-hidden="true" class="sa-text-field-icon sa-text-field-svg"><use href="#{icon}"></use></svg>',
        '</tpl>',
        '<input class="sa-text-field-input" id="{id}-inputEl" type="text" autocomplete="off" value="{value:htmlEncode}"',
            '<tpl if="emptyText"> aria-label="{emptyText:htmlEncode}"</tpl>',
            '<tpl if="emptyText"> placeholder="{emptyText:htmlEncode}"</tpl>',
            '<tpl if="maxLength"> maxlength="{maxLength}"</tpl>',
        '/>',
        '<button aria-label="clear" class="sa-text-field-button sa-text-field-clear"><svg aria-hidden="true" class="sa-text-field-svg"><use href="#sa-icon-clear"></use></svg></button>'
    ],

    initComponent() {
        this.callParent();

        this.setValue(this.value);
    },

    beforeRender() {
        this.callParent();

        Ext.applyIf(this.renderData, {
            emptyText: this.emptyText,
            icon: this.icon === true ? 'sa-icon-search' : this.icon,
            maxLength: this.maxLength,
            value: this.value
        });
    },

    clear() {
        this.setValue('');
        this.fireEvent('clear');
    },

    getFocusEl() {
        return this.inputEl;
    },

    getValue() {
        var el = this.inputEl;

        return el ? el.dom.value : this.value;
    },

    initEvents() {
        this.callParent();

        this.el.on({
            delegate: '.sa-text-field-button',
            scope: this,

            click: this.onButtonClick,
            mousedown: this.onButtonMouseDown
        });

        this.inputEl.on({
            scope: this,

            blur: this.onInputBlur,
            click: this.onInputClick,
            focus: this.onInputFocus,
            input: this.onInputChange,
            keydown: this.onInputKeyDown
        });

        this.updateClearVisibility();
        this.lastValue = this.getValue();
    },

    isFocused() {
        var el = this.inputEl;

        return !!el && el.dom === document.activeElement;
    },

    onButtonClick(ev, el) {
        el = Ext.fly(el);

        var buttons = this.buttons;

        for (let cls in buttons) {
            if (el.hasCls(cls)) {
                this[buttons[cls]]();
            }
        }
    },

    onButtonMouseDown() {
        this.retainFocusCls = true;

        Ext.getDoc().on('mouseup', this.onDocMouseUp, this, {single: true});
    },

    onClearClick() {
        this.inputEl.dom.focus();
        this.clear();
    },

    onDocMouseUp() {
        if (this.retainFocusCls === 'remove') {
            this.removeCls('sa-text-field-focus');
        }

        this.retainFocusCls = false;
    },

    onEnterKeyPress() {
        this.fireEvent('enterkeypress', this);

        this.fireFlushEvent();
    },

    fireFlushEvent() {
        this.fireEvent('flush');
    },

    onEscKeyPress(ev) {
        this.resetValue();
        ev.preventDefault();

        this.fireEvent('esckeypress', this);
    },

    onInputBlur() {
        if (this.retainFocusCls) {
            this.retainFocusCls = 'remove';
        }
        else {
            this.removeCls('sa-text-field-focus');
        }

        this.lastValue = this.getValue();

        this.fireEvent('blur', this);

        this.fireFlushEvent();
    },

    onInputChange() {
        this.updateClearVisibility();

        this.fireEvent('change', this);
    },

    onInputClick() {
        this.inputEl.dom.focus(); 
    },

    onInputFocus() {
        this.retainFocusCls = false;
        this.lastValue = this.getValue();
        this.addCls('sa-text-field-focus');
    },

    onInputKeyDown(ev) {
        switch (ev.getKey()) {
            case ev.ENTER:
                this.onEnterKeyPress(ev);
            break;

            case ev.ESC:
                this.onEscKeyPress(ev);
            break;
        }
    },

    resetValue() {
        this.setValue(this.lastValue);
    },

    select() {
        this.inputEl.dom.select();
    },

    setEmptyText(emptyText) {
        if (this.emptyText !== emptyText) {
            this.emptyText = emptyText;
            this.inputEl.dom.setAttribute('placeholder', Ext.util.Format.htmlEncode(emptyText));
        }
    },

    setValue(value) {
        var el = this.inputEl;

        if (value == null) {
            value = '';
        }
        else {
            value += '';
        }

        this.value = this.lastValue = value;

        if (el) {
            el.dom.value = value;

            this.onInputChange();
        }
    },

    updateClearVisibility() {
        var clearEl = this.el.down('.sa-text-field-clear', true);

        Ext.fly(clearEl).ifCls(!(this.clearButton && this.getValue()), 'sa-text-field-button-hidden');
    }
});
